import { Box, Flex, Text } from '@chakra-ui/react';

export type TRows = Array<{ id: number | string } & any>;
export type TCols<T = { value: any; row: any }> = Array<{
    field: string;
    headerName?: string;
    flex?: number;
    minWidth?: number;
    renderCell: (params: T) => JSX.Element;
    width?: number;
}>;

type TProps = {
    columns: TRows;
    rows: TRows;
    rowClick?: (row: any) => void;
};

const Table = ({ columns, rows = [], rowClick }: TProps) => (
    <Flex flexDirection="column">
        <Flex borderY="1px" borderColor="gray.100" paddingY="16px" marginX="-24px" paddingX="24px">
            {columns.map(item => (
                <Box
                    flex={item.flex}
                    minWidth={item.minWidth && item.minWidth + 'px'}
                    key={item.field}
                    width={item.width && item.width + 'px'}
                >
                    <Text color="gray.500" fontSize="14px" fontWeight={400} lineHeight={1}>
                        {item.headerName}
                    </Text>
                </Box>
            ))}
        </Flex>
        {!rows.length ? (
            <Flex height="250px" alignItems="center" justifyContent="center">
                <Text fontSize={'24px'} fontWeight={500} color="gray.900">
                    No data
                </Text>
            </Flex>
        ) : (
            <Flex flexDirection="column">
                {rows.map((row, index) => (
                    <Flex
                        key={row.id || index}
                        height="72px"
                        alignItems="center"
                        borderBottom={index !== rows.length - 1 && '1px'}
                        borderColor="gray.100"
                        cursor={rowClick && 'pointer'}
                    >
                        {columns.map(col => (
                            <Flex
                                flex={col.flex}
                                minWidth={col.minWidth + 'px'}
                                key={col.field}
                                width={row.width && row.width + 'px'}
                                onClick={!!rowClick && col.field !== 'actions' ? () => rowClick(row) : undefined}
                            >
                                {col.renderCell({ value: row[col.field as keyof typeof row], row: row })}
                            </Flex>
                        ))}
                    </Flex>
                ))}
            </Flex>
        )}
    </Flex>
);

export default Table;
// const headers = [
//     {
//         key: 'job_title',
//         name: 'Job title',
//     },
//     {
//         key: 'department',
//         name: 'Department',
//     },
//     {
//         key: 'employment_type',
//         name: 'Employment type',
//     },
//     {
//         key: 'location',
//         name: 'Location',
//     },
// ];

// const rowsSizes = [4, 3, 2.5, 2.5];

// const JobsTable = ({ data }: TData) => {
//     return (
//         <div ref={scope}>
//             <Grid container display={{ xs: 'none', md: 'flex' }}>
//                 {headers.map((item, index) => (
//                     <Grid item xs={rowsSizes[index]} key={item.key}>
//                         <Box paddingY={3}>
//                             <Typography variant="body2" colorName="grey400">
//                                 {item.name}
//                             </Typography>
//                         </Box>
//                     </Grid>
//                 ))}
//             </Grid>
//             <Box>
//                 {data.map((item, index) => (
//                     <Link key={index} href={PAGES.job} className="custom-table-row">
//                         <Grid container>
//                             <Grid item xs={rowsSizes[0]}>
//                                 <Typography variant="h5" component="p">
//                                     {item.job_title}
//                                 </Typography>
//                             </Grid>
//                             <Grid item xs={rowsSizes[1]}>
//                                 {item.department}
//                             </Grid>
//                             <Grid item xs={rowsSizes[2]}>
//                                 {item.employment_type}
//                             </Grid>
//                             <Grid item xs={rowsSizes[3]}>
//                                 {item.location}
//                             </Grid>
//                         </Grid>
//                     </Link>
//                 ))}
//             </Box>
//         </div>
//     );
// };

// export default JobsTable;
